import React from "react";
import { Navigate } from "react-router-dom";
import { captureClientError } from "./utils/errorReporting";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Log error without hiding the entire page
    console.error("Error boundary caught:", error);
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Caught error:", error, info);
    captureClientError(error, {
      component: 'React ErrorBoundary',
      componentStack: info?.componentStack,
      page: window.location.pathname
    });
  }

  render() {
    if (this.state.hasError) {
      // Redirect immediately
      return <Navigate to="/it-error?error=true" replace />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;



// import React from "react";

// class ErrorBoundary extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = { hasError: false };
//   }

//   static getDerivedStateFromError(error) {
//     // Update state so next render shows fallback UI
//     return { hasError: true };
//   }

//   componentDidCatch(error, info) {
//     // You can log the error to an external service here
//     console.error("Caught by ErrorBoundary:", error, info);
//   }

//   render() {
//     if (this.state.hasError) {
//       // Show a friendly message instead of the red overlay
//       return (
//         <div
//           style={{
//             height: "100vh",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "center",
//             alignItems: "center",
//             backgroundColor: "#f7f7f7",
//             color: "#333",
//             textAlign: "center",
//             fontFamily: "sans-serif",
//           }}
//         >
//           <h1>Something went wrong</h1>
//           <p>Please contact support or refresh the page.</p>
//         </div>
//       );
//     }

//     return this.props.children;
//   }
// }

// export default ErrorBoundary;
